'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _odataFilterBuilder = require('odata-filter-builder');

var _odataFilterBuilder2 = _interopRequireDefault(_odataFilterBuilder);

var _query = require('utilities/query');

var _messages = require('common/messages');

var _companies = require('./companies.html');

var _companies2 = _interopRequireDefault(_companies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _companies2.default,
  bindings: {
    companies: '<',
    regulators: '<',
    adminUsers: '<',
    companyQuery: '<',
    regulatorQuery: '<',
    adminUsersQuery: '<',
    user: '<',
    limitOptions: '<'
  },
  controller: function () {
    function CompaniesComponent($mdDialog, $scope, $state, AccountService, AuthService, CompanyService, PeopleService, RegulatorService, ToastService) {
      'ngInject';

      _classCallCheck(this, CompaniesComponent);

      Object.assign(this, {
        $mdDialog: $mdDialog,
        $scope: $scope,
        $state: $state,
        AccountService: AccountService,
        AuthService: AuthService,
        CompanyService: CompanyService,
        PeopleService: PeopleService,
        RegulatorService: RegulatorService,
        ToastService: ToastService
      });
    }

    _createClass(CompaniesComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.selectedRegulators = [];
        this.selectedAdminUsers = [];
        this.company = -1;
        this.refreshAdminUsers(); // need to do from here to apply the 'admin users' filter to the People OData query
      }
    }, {
      key: 'refreshCompanies',
      value: function refreshCompanies() {
        var _this = this;

        this.promise = this.CompanyService.search(this.companyQuery);
        this.promise.then(function (r) {
          _this.companies = (0, _query.transformODataResponse)(r);
        }).catch(function (error) {
          return _this.ToastService.showError(error);
        });
      }
    }, {
      key: 'onCompanySearchTextChanged',
      value: function onCompanySearchTextChanged(_ref) {
        var searchText = _ref.searchText;

        this.companyQuery = _extends({}, this.companyQuery, {
          filter: (0, _odataFilterBuilder2.default)().contains('MemberName', searchText)
        });

        this.refreshCompanies();
      }
    }, {
      key: 'onCompanyQueryChanged',
      value: function onCompanyQueryChanged(_ref2) {
        var query = _ref2.query;

        this.companyQuery = query;
        this.refreshCompanies();
      }
    }, {
      key: 'refreshRegulators',
      value: function refreshRegulators() {
        var _this2 = this;

        this.promise = this.RegulatorService.search(this.regulatorQuery);
        this.promise.then(function (r) {
          _this2.regulators = (0, _query.transformODataResponse)(r);
        }).catch(function (error) {
          return _this2.ToastService.showError(error);
        });
      }
    }, {
      key: 'onRegulatorSearchTextChanged',
      value: function onRegulatorSearchTextChanged(_ref3) {
        var searchText = _ref3.searchText;

        this.regulatorQuery = _extends({}, this.regulatorQuery, {
          filter: (0, _odataFilterBuilder2.default)().contains('AgentName', searchText)
        });

        this.refreshRegulators();
      }
    }, {
      key: 'onRegulatorQueryChanged',
      value: function onRegulatorQueryChanged(_ref4) {
        var query = _ref4.query;

        this.regulatorQuery = query;
        this.refreshRegulators();
      }
    }, {
      key: 'showCompanyAdd',
      value: function showCompanyAdd() {
        var _this3 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          onCompanyAdded: function onCompanyAdded($event) {
            return _this3.onCompanyAdded($event);
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <company-add-form\n                on-company-changed="onCompanyAdded($event)">\n              </company-add-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
        });
      }
    }, {
      key: 'onCompanyAdded',
      value: function onCompanyAdded(_ref5) {
        var _this4 = this;

        var company = _ref5.company;

        if (company) {
          this.CompanyService.add(company).then(function (r) {
            _this4.$mdDialog.hide();
            _this4.ToastService.showSuccess(_messages.COMPANY_ADDED);

            var companyId = r.data.Id;
            _this4.$state.go('company', { id: companyId });
          }).catch(function (error) {
            return _this4.ToastService.showError(error);
          });
        }
      }
    }, {
      key: 'showRegulatorAdd',
      value: function showRegulatorAdd() {
        var _this5 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          onRegulatorAdded: function onRegulatorAdded($event) {
            return _this5.onRegulatorAdded($event);
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <regulator-add-form\n                dialog-title="Add New Regulator"\n                submit-title="Add Regulator"\n                on-regulator-changed="onRegulatorAdded($event)">\n              </regulator-add-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
        });
      }
    }, {
      key: 'onRegulatorAdded',
      value: function onRegulatorAdded(_ref6) {
        var _this6 = this;

        var regulator = _ref6.regulator;

        if (regulator) {
          this.RegulatorService.add(regulator).then(function () {
            _this6.ToastService.showSuccess(_messages.REGULATOR_ADDED);
            _this6.$mdDialog.hide();
            _this6.refreshRegulators();
          }).catch(function (error) {
            return _this6.ToastService.showError(error);
          });
        }
      }
    }, {
      key: 'showChangeOwnPassword',
      value: function showChangeOwnPassword() {
        var _this7 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          ownPasswordChanged: function ownPasswordChanged($event) {
            return _this7.onOwnPasswordChanged($event);
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <change-password password-changed="ownPasswordChanged($event)">\n              </change-password>\n            </md-dialog-content>\n          </md-dialog>\n          '
        });
      }
    }, {
      key: 'onOwnPasswordChanged',
      value: function onOwnPasswordChanged(_ref7) {
        var _this8 = this;

        var credentials = _ref7.credentials;

        if (credentials && this.user.Username) {
          this.AccountService.changePassword(_extends({
            Username: this.user.Username
          }, credentials)).then(function () {
            _this8.$mdDialog.hide();
            _this8.ToastService.showSuccess(_messages.PASSWORD_CHANGED);
          }).catch(function (error) {
            return _this8.ToastService.showError(error);
          });
        }
      }
    }, {
      key: 'updateAccount',
      value: function updateAccount(_ref8) {
        var _this9 = this;

        var user = _ref8.user;

        if (user) {
          this.AccountService.updateAccount(user).then(function () {
            _this9.ToastService.showSuccess(_messages.ACCOUNT_EDITED);
            _this9.$state.reload();
          }).catch(function (error) {
            return _this9.ToastService.showError(error);
          });
        }
      }
    }, {
      key: 'updateCompliance',
      value: function updateCompliance(_ref9) {
        var _this10 = this;

        var company = _ref9.company;

        this.CompanyService.updateCompliance(company).then(function () {
          _this10.ToastService.showSuccess(_messages.COMPANY_EDITED);
        }).catch(function (error) {
          return _this10.ToastService.showError(error);
        });
      }
    }, {
      key: 'showUserAdd',
      value: function showUserAdd() {
        var _this11 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          accessLevels: this.AuthService.getAccessLevels(),
          onUserAdded: function onUserAdded($event) {
            return _this11.onUserAdded($event);
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n        <md-dialog class="flex-50">\n          <md-dialog-content>\n            <dialog-close/>\n            <user-add-form\n              require-user-type-selection="true"\n              access-levels="accessLevels"\n              on-user-changed="onUserAdded($event)">\n            </user-add-form>\n          </md-dialog-content>\n        </md-dialog>\n        '
        });
      }
    }, {
      key: 'onUserAdded',
      value: function onUserAdded(_ref10) {
        var _this12 = this;

        var user = _ref10.user;

        if (user) {
          this.AccountService.addAccount(_extends({}, user)).then(function () {
            _this12.$mdDialog.hide();
            _this12.ToastService.showSuccess(_messages.USER_ADDED);
          }).catch(function (error) {
            return _this12.ToastService.showError(error);
          });
        }
      }
    }, {
      key: 'regulatorDelete',
      value: function regulatorDelete(regulators) {
        var _this13 = this;

        var confirm = this.$mdDialog.confirm().title('Delete selected regulators?').textContent('Once deleted, the selected regulator(s) cannot be recovered!').ok('Delete').cancel('Cancel');

        this.$mdDialog.show(confirm).then(function () {
          var promises = [];
          for (var i = regulators.length - 1; i >= 0; i -= 1) {
            promises.push(_this13.RegulatorService.delete(regulators[i].RegulatorId));
          }

          Promise.all(promises).then(function () {
            _this13.ToastService.showSuccess(_messages.REGULATOR_DELETED);
            _this13.selectedRegulators = [];
            _this13.refreshRegulators();
          }).catch(function (error) {
            return _this13.ToastService.showError(error);
          });
        });
      }
    }, {
      key: 'refreshAdminUsers',
      value: function refreshAdminUsers() {
        var _this14 = this;

        this.selectedAdminUsers = [];
        var filter = (0, _odataFilterBuilder2.default)();

        if (this.searchText && this.searchText.length) {
          filter = filter.contains('LastName', this.searchText).or(function (x) {
            return x.contains('FirstName', _this14.searchText);
          });
        }

        filter = filter.and(function (x) {
          return x.eq('UserTypeName', 'System Administrator');
        }).and(function (x) {
          return x.ne('UserId', _this14.user.UserId);
        }).and(function (x) {
          return x.eq('IsSysAdminOwner', false);
        }).and(function (x) {
          return x.eq('TypeReferenceId', -1);
        });

        this.promise = this.PeopleService.search(_extends({}, this.adminUsersQuery, {
          filter: filter
        }));

        this.promise.then(function (r) {
          _this14.adminUsers = (0, _query.transformODataResponse)(r);
        }).catch(function (error) {
          return _this14.ToastService.showError(error);
        });
      }
    }, {
      key: 'onAdminSearchTextChanged',
      value: function onAdminSearchTextChanged(_ref11) {
        var searchText = _ref11.searchText;

        this.searchText = searchText;
        this.refreshAdminUsers();
      }
    }, {
      key: 'onAdminQueryChanged',
      value: function onAdminQueryChanged(_ref12) {
        var query = _ref12.query;

        this.query = query;
        this.refreshAdminUsers();
      }
    }, {
      key: 'adminUserAdd',
      value: function adminUserAdd() {
        var _this15 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          onAdminUserAdded: function onAdminUserAdded($event) {
            return _this15.onAdminUserAdded($event);
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n        <md-dialog class="flex-50">\n          <md-dialog-content>\n            <dialog-close/>\n            <admin-user-add-form\n              on-user-changed="onAdminUserAdded($event)">\n            </admin-user-add-form>\n          </md-dialog-content>\n        </md-dialog>\n        '
        });
      }
    }, {
      key: 'onAdminUserAdded',
      value: function onAdminUserAdded(_ref13) {
        var _this16 = this;

        var user = _ref13.user;

        if (user) {
          this.AccountService.addAccount(_extends({}, user)).then(function () {
            _this16.$mdDialog.hide();
            _this16.ToastService.showSuccess(_messages.USER_ADDED);
            _this16.refreshAdminUsers();
          }).catch(function (error) {
            return _this16.ToastService.showError(error);
          });
        }
      }
    }, {
      key: 'adminUserEdit',
      value: function adminUserEdit(user) {
        var _this17 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          user: _angular2.default.copy(user),
          onAdminUserEdited: function onAdminUserEdited($event) {
            return _this17.onAdminUserEdited($event);
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <admin-user-edit-form\n                user="user"\n                on-user-changed="onAdminUserEdited($event)">\n              </admin-user-edit-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
        });
      }
    }, {
      key: 'onAdminUserEdited',
      value: function onAdminUserEdited(_ref14) {
        var _this18 = this;

        var user = _ref14.user;

        if (user) {
          this.AccountService.updateAccount(user).then(function () {
            _this18.ToastService.showSuccess(_messages.USER_EDITED);
            _this18.$mdDialog.hide();
            _this18.refreshAdminUsers();
          }).catch(function (error) {
            return _this18.ToastService.showError(error);
          });
        }
      }
    }, {
      key: 'adminUserDelete',
      value: function adminUserDelete(users) {
        var _this19 = this;

        var confirm = this.$mdDialog.confirm().title('Delete selected users?').textContent('Once deleted, the selected user(s) cannot be recovered!').ok('Delete').cancel('Cancel');

        this.$mdDialog.show(confirm).then(function () {
          var promises = [];
          for (var i = users.length - 1; i >= 0; i -= 1) {
            promises.push(_this19.AccountService.deleteAccount(users[i].UserId));
          }

          Promise.all(promises).then(function () {
            _this19.ToastService.showSuccess(_messages.USER_DELETED);
            _this19.refreshAdminUsers();
          }).catch(function (error) {
            return _this19.ToastService.showError(error);
          });
        });
      }
    }, {
      key: 'showChangeAdminPassword',
      value: function showChangeAdminPassword(user) {
        var _this20 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          passwordChanged: function passwordChanged($event) {
            return _this20.onAdminPasswordChanged($event);
          },
          credentials: {
            UserId: user.UserId
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <change-password password-changed="passwordChanged($event)"\n                require-current-password="false"\n                credentials="credentials">\n              </change-password>\n            </md-dialog-content>\n          </md-dialog>\n          '
        });
      }
    }, {
      key: 'onAdminPasswordChanged',
      value: function onAdminPasswordChanged(_ref15) {
        var _this21 = this;

        var credentials = _ref15.credentials;

        if (credentials) {
          this.AccountService.forcePasswordChange(_extends({}, credentials)).then(function () {
            _this21.$mdDialog.hide();
            _this21.ToastService.showSuccess(_messages.PASSWORD_CHANGED);
            _this21.selectedAdminUsers = [];
          }).catch(function (error) {
            return _this21.ToastService.showError(error);
          });
        }
      }
    }, {
      key: 'setUserLockout',
      value: function setUserLockout(_ref16) {
        var _this22 = this;

        var userId = _ref16.userId,
            isLocked = _ref16.isLocked;

        this.AccountService.setLockoutStatus(userId, isLocked).then(function () {
          _this22.ToastService.showSuccess(_messages.ACCOUNT_LOCKOUT_EDITED);
        }).catch(function (error) {
          return _this22.ToastService.showError(error);
        });
      }
    }]);

    return CompaniesComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/admin/companies/companies.component.js